<script>
export default {
    name: "PrintCOATransactions",

    data() {

        return {
            transactions: [],
        };
    },

    computed: {

        totalDebit() {
            if(!this.transactions.length) return 0;

            return this.transactions.map(trx => parseFloat(trx.debitAmount))
                .reduce((sum, debit) => sum+debit);
        },

        totalCredit() {
            if(!this.transactions.length) return 0;

            return this.transactions.map(trx => parseFloat(trx.creditAmount))
                .reduce((sum, cr) => sum+cr);
        },

        totalBal() {
            if(!this.transactions.length) return 0;

            return this.transactions.map(trx => parseFloat(trx.runningBalance))
                .reduce((sum, bal) => sum+bal);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchTransactions() ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchTransactions() {
            let url = `Accounting/GetCOATransactions`;
                url += `?AsFrom=${this.$route.query.from}`;
                url += `&AsTo=${this.$route.query.to}`;
                url += `&COAID=${this.$route.query.coaid}`;

            return this.$http.get(url).then(({ data }) => {
                this.transactions = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <div class="w-full">
        <table class="table text-sm">
            <thead>
                <tr>
                    <th class="p-tiny">Id</th>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Account</th>
                    <th class="p-tiny">Memo</th>
                    <th class="p-tiny">Debit</th>
                    <th class="p-tiny">Credit</th>
                    <th class="p-tiny">Running Bal</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="trx in transactions" :key="trx.ledgerID">
                    <td class="p-tiny">{{ trx.ledgerID }}</td>
                    <td class="p-tiny">{{ trx.date | dateFormat }}</td>
                    <td class="p-tiny">{{ trx.coaName }}</td>
                    <td class="p-tiny">{{ trx.memo }}</td>
                    <td class="p-tiny">{{ trx.debitAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ trx.creditAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ trx.runningBalance | numberFormat }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th class="p-tiny text-right" colspan="4">Total</th>
                    <th class="p-tiny">{{ $formatCurrency(totalDebit) }}</th>
                    <th class="p-tiny">{{ $formatCurrency(totalCredit) }}</th>
                    <th class="p-tiny">{{ $formatCurrency(totalBal) }}</th>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
</template>
